<template>
	<div class="index" style="margin-bottom: 40px;">
		<div style="width: 1200px; margin: 0 auto;">
			<div class="top_title">
            <!-- 左侧位置 -->
            <div class="top_title_left">
                 <div class="left_icon">
                    <img src="../../assets/xiangning/news_detail/location.png" alt="">
                </div>
                <div class="left_text" v-if="$route.query.type=='tzgg'">
                    当前位置：通知公告>详情
                </div>
                <div class="left_text" v-if="$route.query.type=='dwgk'">
                    当前位置：党务公开>详情
                </div>
                <div class="left_text" v-if="$route.query.type=='zcjd'">
                    当前位置：政策解读>详情
                </div>
            </div>
            <div class="right_back">
                <div class="right_back_icon"><img src="../../assets/xiangning/news_detail/back.png" alt=""></div>
                <div @click="$router.go(-1)" >返回</div>
            </div>

           </div>
           <!-- 文章内容 -->
           <div class="artical_content">
            <!-- 上方文章标题 -->
               <div class="artical_content_title">
                   <div class="artical_content_title_main">
                  {{ title }}
                   </div>
                   <!-- 发布时间及来源 -->
                   <div class="artical_content_title_time">
                      <span>发布时间：{{ pubtime!=''?pubtime:'暂无' }}</span>
                      <!-- <span>来源：人民网</span> -->
                   </div>
                   <!-- 调整字号大小 -->
                   <div class="changeFontSize"  v-if="$route.query.type!='zcjd'">
                      <span>字号调节：</span>
                      <!-- 字号变大 -->
                      <div @click="changeFontSize('add')" class="changeFontSize_A"><img src="../../assets/xiangning/news_detail/fontAdd.png" alt=""></div>
                      <!-- 字号变小 -->
                      <div @click="changeFontSize('red')" class="changeFontSize_A"><img src="../../assets/xiangning/news_detail/fontR.png" alt=""></div>
                   </div>
                   
               </div>
               <!-- 下方文章内容 -->
               <div v-html="content" class="artical_content_main_text" :style="{fontSize:sizes+'px',
            lineHeight:sizes*2+'px', textIndent:sizes*2+'px'}">
               
             </div>
           </div>
           <!-- 底部附件下载如果有数据则显示-->
           <div class="bottom_download" v-if="FileList.length>0">
               <div class="bottom_download_title">附件下载：</div>
               <!-- 右侧附件列表 -->
               <div class="bottom_download_right">
                    <div class="bottom_download_right_item" v-for="item in FileList">
                        <!-- 图标 -->
                         <div class="bottom_download_right_item_icon"><img src="../../assets/xiangning/news_detail/download_icon.png" alt=""></div>
                         <div class="bottom_download_right_item_name">
                            <a :href="item.ment_url+'?response-content-type=application/octet-stream'" :download="item.title">{{ item.title }}</a>
                        </div>
                    </div>
               </div>
           </div>
		   <!-- 返回顶部 -->
		   <div class="backTop" v-if="isShow" @click="toTopHandle">
            <img src="../../assets/xiangning/news_detail/backTop.png" alt="isShow">
        </div>
		</div>
			
	</div>
</template>
<script>
import { news } from '@/axios';
	export default{
		data(){
			return{

				index:0,
				// 返回顶部
				isShow:false,
				// 字体大小,
				sizes:14,
                content:'',
                title:'',
                pubtime:'',
                FileList:[]

			}
		},
		// components:{ Title },
		methods:{
			handleScroll(){
                        let that=this
                        // 判断页面的滚动距离如果大于500展示回到顶部按钮
                        if (window.pageYOffset>500) {
                            that.isShow=true
                        }else{
                            that.isShow=false
                        }
                    },
                    toTopHandle(){
                        window.scrollTo({ 
                            top: 0, 
                            behavior: "smooth" 
                        });
                    },
                    // 改变页面字体大小
                    changeFontSize(val){
                        let that=this
                    if (val=='add') {
                        // 加大字号
                        that.sizes=that.sizes+2
                    }else{
                        that.sizes=that.sizes-2
                    }
                 
                    },
                    // 获取新闻详情
                    getNewsDetail(){
                          let that=this
                          if (this.$route.query.type=='tzgg') {
                            news.TzggDetail({id:that.$route.query.id}).then((res)=>{
                            if (res.code==200) {
                                that.content=res.data.content
                                that.title=res.data.title
                                that.pubtime=res.data.pub_time
                                that.FileList=res.data.file
                            }
                          })
                          }else if (this.$route.query.type=='zcjd') {
                            news.getZcjdDetail({id:that.$route.query.id}).then((res)=>{
                            if (res.code==200) {
                                that.content=res.data.content
                                that.title=res.data.title
                                that.pubtime=res.data.pub_time
                            }
                          })
                          }else if (this.$route.query.type=='dwgk') {
                            news.dwgkDetail({id:that.$route.query.id}).then((res)=>{
                            if (res.code==200) {
                                that.content=res.data.content
                                that.title=res.data.title
                                that.pubtime=res.data.day
                                that.FileList=res.data.file
                            }
                          })
                          }
                    }
			
		  },
		mounted(){
			  // 给页面添加滑动时间
			  window.addEventListener("scroll", this.handleScroll);
              this.getNewsDetail()
	           
		},
		computed: {
                    // 计算属性，返回当前是否应该显示返回顶部按钮
                    shouldShowBackToTop() {
                    return this.scrollY >= this.threshold; // 假设滚动距离超过 500px 时显示按钮
                    }
                },
		created() {
		
		}
	}
</script>

<style >
		.top_title{
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #D8D8D8;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.top_title_left{
    display: flex;
    align-items: center;
}
.left_icon{
    width: 20px;
    height: 20px;
    margin-right: 5px;
}
img{
    width: 100%;
    height: 100%;
}
.left_text{
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #999999;
    height: 20px;
    line-height: 20px;
}
.right_back{
    display: flex;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
    margin-right: 10px;
}
.right_back:hover{
    font-weight: 800;
    color: #C9010A;
}
.right_back_icon{
    height: 10px;
    width: 12px;
    margin-right: 5px;
}
.right_back_icon img{
    height: 100%;
    width: 100%;
}
.artical_content{
    border-bottom: 1px solid #D8D8D8;
}
.artical_content_title{
    margin-top: 30px;
    padding: 0 140px;
    position: relative;
}
.artical_content_title_main{
    width: 100%;
    white-space: wrap;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 24px;
    font-weight: 800;
    text-align: center;
    letter-spacing: 0em;

    color: #000000;
    margin-bottom: 10px;
}
.artical_content_title_time{
    font-family: PingFangSC-Regular;
    text-align: center;
}
.artical_content_title_time span{
     margin-right: 10px;
     font-size: 14px;
     font-weight: normal;
     text-align: center;
     letter-spacing: 0em;
 
     color: #000000;
} 
.artical_content_main_text{
    width: 100%;
    margin-top: 17px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    line-height: 28px;
    text-align: justify; 
    letter-spacing: 0em;
    color: #000000;
    /* text-indent: ; */

}
.artical_content_main_text p{
    text-indent: 28px;
    font-family: PingFangSC-Regular;
    /* font-size: 14px; */
    font-weight: normal;
    /* line-height: 28px; */
    text-align: justify;
    letter-spacing: 0em;
    color: #000000;
    margin-bottom: 28px;
}
.artical_content_main_text p img{
    display: block;
    max-width:840px;
    /* height: 462px; */
    margin: 0 auto 28px auto;
}
.artical_content_main_text img{
    display: block;
    max-width:840px;
    /* height: 462px; */
    margin: 0 auto 28px auto;

}
.bottom_download{
    width: 100%;
    padding-top: 20px;
    display: flex;
}
.bottom_download_title{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    /* color: #1C76FD; */
}
.bottom_download_right_item{
    display: flex;
    height: 16px;
    margin-bottom: 16px;
    
}
.bottom_download_right_item_icon{
    width: 16px;
    height: 16px;
    margin-right: 5px;
}
.bottom_download_right_item_name a{
    text-decoration: none;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    display: flex;
    align-items: center;
    letter-spacing: 0em;
    color: #1C76FD;
}
.backTop{
    width: 70px;
    height: 70px;
    position: fixed;
    top: 500px;
    right: 224px;
    /* display: none; */
}
.backTop img{
    width: 70px;
    height: 70px;
}
.changeFontSize{
    z-index: 99;
    position: absolute;
    top:3PX;
    right: 0;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #1C76FD;
    display: flex;
    align-items: center;
}
.changeFontSize_A{
    display: inline-block;
    width: 17px;
    height: 28px;
    margin-left: 10px;
}

</style>
